// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ab1efba7","453":"66fb69b2","732":"9badbce2","977":"6fd3e0fb"}[chunkId] + ".chunk.js";
};